import ModalContentWrapper from "root/Modals/ModalContentWrapper";


const ModalRegistrationValidation = ({onClose, message, onSaveComplete, mode}) =>
{
    return (
        <ModalContentWrapper className="modal-wrapper" >
        <h2>Submit Registration</h2>
            {message}
    </ModalContentWrapper>
    )
}

export default ModalRegistrationValidation;